import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/customer-care.scss";

function SizeGuide() {
  return (
    <main className="policy-page customer-care size-guide">
      <header>
        <p className="eyebrow">Fit &amp; proportion</p>
        <h1>Size guide</h1>
        <p>Use these body measurements as a starting point, then check the fit description on each product page.</p>
      </header>
      <article className="policy-copy">
        <section>
          <h2>Clothing measurements</h2>
          <div className="size-table-wrap">
            <table>
              <thead><tr><th>Size</th><th>Bust</th><th>Waist</th><th>Hip</th></tr></thead>
              <tbody>
                <tr><th>34 / XS</th><td>80–83 cm</td><td>62–65 cm</td><td>88–91 cm</td></tr>
                <tr><th>36 / S</th><td>84–87 cm</td><td>66–69 cm</td><td>92–95 cm</td></tr>
                <tr><th>38 / M</th><td>88–91 cm</td><td>70–73 cm</td><td>96–99 cm</td></tr>
                <tr><th>40</th><td>92–95 cm</td><td>74–77 cm</td><td>100–103 cm</td></tr>
                <tr><th>42</th><td>96–100 cm</td><td>78–82 cm</td><td>104–108 cm</td></tr>
              </tbody>
            </table>
          </div>
        </section>
        <section>
          <h2>How to measure</h2>
          <p>Measure the bust around its fullest point, the waist at its natural narrowest point and the hip around the fullest point. Keep the tape level and comfortably close to the body.</p>
        </section>
        <section>
          <h2>Between sizes?</h2>
          <p>Choose according to the garment's intended fit. For close-fitting pieces, use the larger measurement; for oversized pieces, compare the product fit notes. Contact <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> for personal guidance.</p>
        </section>
        <section>
          <h2>Accessories</h2>
          <p>Scarf dimensions and belt widths are listed on their product pages. Belt sizes refer to the measurement from the buckle pin to the centre hole.</p>
          <Link className="text-link align-left" to="/shop?category=Accessories">Shop accessories</Link>
        </section>
      </article>
    </main>
  );
}

export default SizeGuide;
